import classNames from 'classnames';
import { useEffect, useMemo, useRef, useState } from 'react';
import { twMerge } from 'tailwind-merge';

export interface MaterialTextInputProps {
  width?: string;
  prefix?: any;
  suffix?: any;
  type?: string;
  label?: any;
  value?: string;
  autoFocus?: boolean;
  max?: string;
  onChange?: any;
  onBlur?: any;
  onPressEnter?: any;
  errType?: string;
  autoComplete?: string;
  /**报错的状态 */
  hasError?: boolean;
  id?: string;
  className?: string;
  suffixClassName?: string;
  inputClassName?: string;
  maxLength?: number;
  onFocus?: any;
  placeholder?: string;
  dataTestId?: string;
}

export default function MaterialTextInput(props: MaterialTextInputProps) {
  const { hasError = false, id = '', className, suffixClassName, inputClassName, dataTestId } = props;
  const inputEl = useRef(null);
  const errTypeTxt = useMemo(() => (props.errType ? `-${props.errType}` : ''), []);
  const labelRef = useRef(null);

  function handleChange(e) {
    props.onChange(e.target.value);
  }

  function handleKeyDown(e) {
    e.keyCode === 13 && props?.onPressEnter?.();
  }

  const handleBlur = e => {
    props.onBlur?.(e.target.value);
  };

  const handleFocus = e => {
    props.onFocus?.(e.target.value);
  };

  useEffect(() => {
    if (!!props?.autoFocus) {
      inputEl?.current?.focus();
    }
  }, []);

  return (
    <label
      data-testid={`${dataTestId}-label`}
      ref={labelRef}
      htmlFor={id}
      className={twMerge(
        'relative w-auto flex items-center py-[6px] pl-4 pr-2 border-[2px] border-solid border-surface-100-hairline rounded-400 focus-within:border-surface-100-fg-default',
        hasError && 'border-input-100-fg-critical',
        className
      )}>
      {!!props.prefix && (
        <div
          data-testid={`${dataTestId}-prefix`}
          className="relative flex justify-center items-center flex-none"
          data-role={`materal-text-input-prefix`}>
          {props.prefix}
        </div>
      )}
      <div data-testid={`${dataTestId}-input-container`} className="relative h-[34px] flex-1 w-full pl-3 pr-2">
        {props?.label && !!props.value && (
          <span
            data-testid={`${dataTestId}-label-text`}
            className="absolute top-0 left-3 overflow-hidden whitespace-nowrap text-surface-100-fg-minor enki-body-2xs z-10">
            {props?.label}
          </span>
        )}
        {props?.placeholder && !props.value && (
          <span
            data-testid={`${dataTestId}-placeholder-text`}
            className="text-surface-100-fg-minor enki-body-sm-medium absolute top-[50%] -translate-y-[50%] left-[15px] right-[9px] overflow-hidden whitespace-nowrap text-ellipsis z-10 pointer-events-none">
            {props?.placeholder}
          </span>
        )}
        <input
          data-testid={`${dataTestId}-input`}
          style={{ transform: 'translateZ(1px)' }}
          ref={inputEl}
          id={id}
          value={props.value || ''}
          className={twMerge(
            'w-full h-full bordr-none outline-none enki-body-sm-medium leading-none !autofill:text-surface-100-fg-default bg-transparent',
            props?.label && !!props.value && 'pt-[14px] box-border',
            inputClassName
          )}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          type={props?.type}
          max={props?.max}
          // placeholder={props?.placeholder}
          autoComplete={props?.autoComplete}
          maxLength={props.maxLength}
          spellCheck={false}
        />
      </div>
      {!!props.suffix && (
        <div
          data-testid={`${dataTestId}-suffix`}
          className="flex items-center flex-none"
          data-role={`materal-text-input-suffix`}>
          {props.suffix}
        </div>
      )}
    </label>
  );
}
